// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatListMediaBody = {
  chatId: string;
  cursor?: string | null;
  limit?: number | null;
};

export type typeChatListMediaOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      messageId: string;
      mediaObjectId: string;
      kind: "image" | "gif";
      sentAtIso: string;
    }[];
    nextCursor?: string | null;
  };
};

export type typeChatListMediaOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListMediaOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListMediaOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatListMediaBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["chatId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatListMedia(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatListMediaBody);
  }

  return async function postChatListMedia(
    payload: typeChatListMediaBody,
  ): Promise<typeChatListMediaOutput200 | typeChatListMediaOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatListMedia" failed before calling the network. #931fe40772cb`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#931fe40772cb" },
        },
        data: null,
      } as typeChatListMediaOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/list-media`,
      httpMethod: "POST",
      options,
    })) as typeChatListMediaOutput200 | typeChatListMediaOutput400;
  };
}
